import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private readonly secretKey =
    "=1gz%b4)Kk$qs1oJ%m)7,[@IE{aFIq~-ZE(C{LOnr`95$)l0!+.htxw>Pr~l=&4V2GOr@yy6Y%s?XrF0A";

  constructor() {}
  private readonly platformId = inject(PLATFORM_ID);

  /**
   * Armazena um valor criptografado no localStorage.
   *
   * @param key Chave para armazenar o valor.
   * @param value Valor a ser armazenado.
   */
  setItem(key: string, value: any): void {
    const encryptedValue = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      this.secretKey,
    ).toString();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, encryptedValue);
    }
  }

  /**
   * Recupera um valor descriptografado do localStorage.
   *
   * @param key Chave do valor a ser recuperado.
   * @returns Valor descriptografado ou null se a chave não existir.
   */
  getItem(key: string): any {
    if (isPlatformBrowser(this.platformId)) {
      const encryptedValue = localStorage.getItem(key);
      if (encryptedValue) {
        try {
          const decryptedBytes = CryptoJS.AES.decrypt(
            encryptedValue,
            this.secretKey,
          );
          const decryptedValue = decryptedBytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decryptedValue);
        } catch (error) {
          console.error("Erro ao descriptografar o valor:", error);
          return null;
        }
      }
    }
    return null;
  }

  getItemAsync(key: string): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        if (isPlatformBrowser(this.platformId)) {
          const encryptedValue = localStorage.getItem(key);
          if (encryptedValue) {
            try {
              const decryptedBytes = CryptoJS.AES.decrypt(
                encryptedValue,
                this.secretKey,
              );
              const decryptedValue = decryptedBytes.toString(CryptoJS.enc.Utf8);
              resolve(JSON.parse(decryptedValue)); // Retorna o valor descriptografado
            } catch (error) {
              console.error("Erro ao descriptografar o valor:", error);
              reject(null); // Rejeitar caso haja erro na descriptografia
            }
          } else {
            resolve(null); // Resolvido como null caso a chave não exista
          }
        } else {
          resolve(null); // Resolvido como null caso não esteja no navegador
        }
      } catch (error) {
        console.error("Erro ao acessar localStorage:", error);
        reject(error); // Rejeitar em caso de erro inesperado
      }
    });
  }

  /**
   * Remove um item do localStorage.
   *
   * @param key Chave do item a ser removido.
   */
  removeItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }

  /**
   * Limpa todo o localStorage.
   */
  clear(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
